// extracted by mini-css-extract-plugin
export default {"wrapper":"calendarPeriodInputLayout_wrapper__edVjI"};